export const HORIZONTAL_PADDING = {
    xs: 14,
    md: 16,
    lg: 32,
};
